import { Tooltip, useTheme } from "@material-ui/core";
import useStyles from "./HorizontalBarChart.styles";
import PropTypes from "prop-types";

const getColorByIndex = (index) => {
  const theme = useTheme();
  const colors = [
    theme.custom.color.apple,
    theme.custom.color.gold,
    theme.custom.color.silver,
  ];
  return colors[index % colors.length];
};

const HorizontalBarChart = ({ values }) => {
  const classes = useStyles();
  const mainValue = values[0].toFixed(1);
  let accumulatedWidth = 0;
  const chartItems = values.map((value, index) => {
    accumulatedWidth += value;
    const style = {
      width: `${accumulatedWidth}%`,
      backgroundColor: getColorByIndex(index),
      zIndex: values.length - index,
    };

    return (
      <Tooltip
        key={index}
        title={`${value.toFixed(1)}%`}
        arrow
        placement="top-end"
      >
        <div className={classes.chartItem} style={style} />
      </Tooltip>
    );
  });

  return (
    <div className={classes.chartContainer}>
      {chartItems}
      {!!values[0] && (
        <div className={classes.chartItemLabel}>{mainValue}%</div>
      )}
    </div>
  );
};

HorizontalBarChart.propTypes = {
  values: PropTypes.array,
};

export { HorizontalBarChart };
